import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";

@Injectable({
	providedIn: "root",
})
export class AuthGuardService {
	private authService = inject(AuthService);
	private router = inject(Router);

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if (this.authService.isAuth()) {
			return true;
		}
		if (state.url == "/") {
			this.router.navigate(["auth"]);
		} else {
			this.router.navigate(["auth"], {
				queryParams: { returnUrl: state.url },
			});
		}
		return false;
	}
}
